export default __webpack_public_path__ + "static/media/library.60b0fe8c.jpg";